import React from 'react';

export interface UserAuth {
  email: string;
  company_id: string;
  location_ids: string[];
  has_auth_for_sd_record_viewer_service: boolean;
}

export const UserAuthContext = React.createContext<UserAuth | undefined>(
  undefined
);
